import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';
import {
    CreateCustomListRequest,
    CustomListDetail,
} from '../types/CustomListSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const createCustomList = createAsyncThunk<
    CustomListDetail,
    CreateCustomListRequest,
    ThunkConfig<string | string[]>
>('customList/createCustomList', async (payload, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.post<CustomListDetail>(
            `/v1/custom-lists/`,
            payload,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue(getApiErrorMessage(e));
    }
});
